import { render, staticRenderFns } from "./studyGardens_ec.vue?vue&type=template&id=3dbd7aba&scoped=true&"
import script from "./studyGardens_ec.vue?vue&type=script&lang=js&"
export * from "./studyGardens_ec.vue?vue&type=script&lang=js&"
import style0 from "./studyGardens_ec.vue?vue&type=style&index=0&lang=less&"
import style1 from "./studyGardens_ec.vue?vue&type=style&index=1&id=3dbd7aba&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dbd7aba",
  null
  
)

component.options.__file = "studyGardens_ec.vue"
export default component.exports